import React from "react";

const CommonMapContext = React.createContext({});

const CommonMapProvider = ({ children }) => {
  const [map, setMap] = React.useState(null);
  const [center, setCenter] = React.useState();
  const [zoom, setZoom] = React.useState();
  const [heading, setHeading] = React.useState();
  // const
  const [selectedFloorplan, setSelectedFloorplan] = React.useState(null);
  const [floorplanImage, setFloorplanImage] = React.useState(null);

  return (
    <CommonMapContext.Provider
      value={{
        map,
        setMap,
        center,
        setCenter,
        zoom,
        setZoom,
        heading,
        setHeading,
        selectedFloorplan,
        setSelectedFloorplan,
        floorplanImage,
        setFloorplanImage,
      }}
    >
      {children}
    </CommonMapContext.Provider>
  );
};

export { CommonMapProvider, CommonMapContext };
